import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

export default class extends Controller {
  static values = {
    heartbeatInterval: { type: Number, default: 120000 }
  }

  connect() {
    this.subscribeToPresence()
    this.startHeartbeat()
  }

  disconnect() {
    this.stopHeartbeat()
    this.unsubscribeFromPresence()
  }

  subscribeToPresence() {
    console.log("[PresenceController] Subscribing to PresenceChannel...")
    this.channel = consumer.subscriptions.create("PresenceChannel", {
      connected: () => {
        console.log("[PresenceChannel] ✅ Connected successfully")
      },

      disconnected: () => {
        console.log("[PresenceChannel] ❌ Disconnected")
      },

      received: (data) => {
        console.log("[PresenceChannel] 📨 Received data:", data)
        const { user_id, online } = data
        this.updateUserStatus(user_id, online)
      }
    })
  }

  unsubscribeFromPresence() {
    if (this.channel) {
      this.channel.unsubscribe()
      this.channel = null
    }
  }

  startHeartbeat() {
    console.log(`[PresenceController] Starting heartbeat (every ${this.heartbeatIntervalValue}ms)`)
    this.heartbeatTimer = setInterval(() => {
      if (this.channel) {
        console.log("[PresenceController] 💓 Sending heartbeat...")
        this.channel.perform("heartbeat")
      }
    }, this.heartbeatIntervalValue)
  }

  stopHeartbeat() {
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer)
      this.heartbeatTimer = null
    }
  }

  updateUserStatus(userId, online) {
    console.log(`[PresenceController] Updating status for user ${userId}: ${online ? 'ONLINE' : 'OFFLINE'}`)
    const indicators = document.querySelectorAll(`[data-user-status="${userId}"]`)
    console.log(`[PresenceController] Found ${indicators.length} indicator(s) for user ${userId}`)

    indicators.forEach(indicator => {
      if (online) {
        indicator.classList.remove("bg-gray-400")
        indicator.classList.add("bg-green-500")
        console.log(`[PresenceController] User ${userId} set to ONLINE (green)`)
      } else {
        indicator.classList.remove("bg-green-500")
        indicator.classList.add("bg-gray-400")
        console.log(`[PresenceController] User ${userId} set to OFFLINE (gray)`)
      }
    })
  }
}
